/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import {
  AutoGroupTypes,
  CalculatedParams,
} from '@linc-technologies/linced-common/enums/group-auto-groups';
import GroupType from '@linc-technologies/linced-common/enums/group-type';
import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { isEmpty } from '@ember/utils';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { uniq } from '@linc-technologies/linced-common/utils/arrays';

export default class InsightsRoute extends Route {
  queryParams = {
    includeFormers: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  model(params) {
    let group = this.modelFor('group');
    let includeFormer = false;

    // Determine whether this is a type of autogroup for which we should load
    // former students (who are current group members).
    let isAutoGroup = group.get('type') === GroupType.AUTO;
    let isCalculated = group.get('autoGroupType') === AutoGroupTypes.CALCULATED;
    let isRecentLeavers =
      group.get('params.type') === CalculatedParams.RECENT_LEAVERS;
    let isCurrentStudents =
      group.get('params.type') === CalculatedParams.CURRENT_STUDENTS;
    let isEnrolledStudents =
      group.get('params.type') === CalculatedParams.ENROLLED_STUDENTS;
    if (
      isAutoGroup &&
      isCalculated &&
      (isRecentLeavers || isCurrentStudents || isEnrolledStudents)
    ) {
      includeFormer = true;
    }

    if (!isEmpty(params.includeFormers)) {
      includeFormer = params.includeFormers;
    }

    return hash({
      group,
      includeFormer,
      learners: this.store.query('person', {
        type: PersonType.LEARNER,
        groupId: group.id,
        includeFormer,
      }),
      goalSubjects: this.store.query('goals/subject', {
        trackable: true,
      }),
      assessmentPages: this.store.query('posts/page', {
        type: PersonType.LEARNER,
        hasAssessments: true,
      }),
      milestones: this.store.query('milestones/milestone', {
        progressionType: ProgressionType.PROGRESSION,
      }),
    });
  }

  async afterModel(model) {
    model.assessments = [];
    if (model.assessmentPages.length > 0) {
      // grab the assessments linked to the page in question after it has
      // resolved so we can obtain the enabled page linked assessment IDs.
      let assessments = uniq(
        model.assessmentPages.reduce((ids, page) => {
          ids.push(...page.assessment_ids);
          return ids;
        }, []),
      );

      if (assessments.length > 0) {
        let assessmentIds = JSON.stringify(assessments);
        // query gives a plain Promise. Wait for the records, because the
        // controllers and child routes read the array.
        model.assessments = await this.store.query('assessments/assessment', {
          assessmentIds,
        });
      }
    }
  }
}
